import styled from "styled-components";
import { theme } from '../../theme'

export const FilterBtn = styled.div`
    background-color: ${theme.colors.mainWhite};
    color: ${theme.colors.black};
    border: 1px solid #868E96;
    border-radius: 4px;
    padding: 1rem;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 1.4rem;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;

    .icon-container {
        width: 1.686rem;
        height: 2.065rem;
        margin-right: 4.5px;

        svg {
            width: 100%;
            height: 100%;
        }
    }
`
export const StyledTopWrapper = styled.div`
    background-color: ${({ bgColor }) => (bgColor ? bgColor : theme.colors.mainBlue)};
`

export const StyledContainer = styled.div`
    margin: 0 auto;
    padding: 4rem 1rem;
    max-width: 730px;
`

export const StyledNextPageDivContainer = styled.div`
    margin: 0 auto;
    padding: 4px 1rem;
    max-width: 730px;
    display: flex;
    align-items: center;

    .score-icon-div {
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 1.2rem;

        .check-icon-container {
            width: 2rem;
            height: 2rem;
            margin-right: 5px;
            color: #979797;
            svg {
                width: 100%;
                height: 100%;
            }
        }
    }

    .class-icon-div {
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 1.2rem;
        margin-left: 4rem;

        .check-icon-container {
            width: 2rem;
            height: 2rem;
            margin-right: 5px;
            color: #979797;
            svg {
                width: 100%;
                height: 100%;
            }
        }
    }

    .next-page-btn-div {
       margin-left: auto;
    }
`

export const StyledMainContentWrapper = styled.div`
background-color: ${theme.colors.grey03};
height: ${({ fullHeight }) => (fullHeight && '100%')};
`
export const StyledNextPageDiv = styled.div`
background-color: ${theme.colors.mainWhite};

`
export const StyledContent = styled.div`
color: ${theme.colors.mainWhite} !important;
    .top {        
        .subject-title {
            font-weight: 700;
            font-size: 5.1rem;
            
            @media only screen and (max-width: 326px) {
                font-size: 4.1rem;
            }
        }
    }

    .bottom {
        font-size: 1.2rem;
        color: #FFFFFF;
        display: flex;
        justify-content: space-between;
        
        .result-score {
            font-weight: 700;
            font-size: 3rem;
        }
    }
    /* .download-result-btn {
        .download-icon {
            width: 2rem;
            height: 2rem;

            svg {
                width: 100%;
                height: 100%;
            }
        }
    } */
`
